import { Component, OnInit, ViewChild } from '@angular/core';
import { PositionService } from '../../service/position.service';
import { Wallet } from '../../../model/Wallet';
import { BITFINEX_LABEL, Exchange, EXCHANGES } from '../../../model/constants';
import { ActivatedRoute } from '@angular/router';
import { BitfinexLoan } from '../../../model/BitfinexLoan';
import { ProgressBarModel } from '../../../model/ProgressBarModel';
import { PullEvent } from '../../../model/PullEvent';
import { MappingService } from '../../service/mapping.service';
import { UserCache } from '../../../model/UserCache';
import { RecalculateTargetInUSDEvent } from '../../../model/RecalculateTargetInUSDEvent';
import { RecalculateTargetInGivenCurrencyEvent } from '../../../model/RecalculateTargetInGivenCurrencyEvent';
import { Pos } from '../../../model/Pos';
import { SessionService } from '../../service/session.service';
import { HeaderComponent } from '../header/header.component';
import { ToastrService } from 'ngx-toastr';
import { BitfinexCurrencyEnabledChange } from '../../../model/BitfinexCurrencyEnabledChange';
import { DecimalPipe } from '@angular/common';
import { CurrencyPosition } from '../../../model/currency-position';
import { initApplicationSelector } from '../../../store/Application/ApplicationSelector';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/Application/ApplicationReducer';
import { EnvironmentType } from '../../../model/EnvironmentType';
import { ServerConfig } from '../../../model/ServerConfig';
import { EmptyTargetEvent } from '../../../model/EmptyTargetEvent';
import { NullTargetEvent } from '../../../model/NullTargetEvent';
import { Json } from '../../../model/Json';
import { DisableAllCurrencyForAccountEvent } from '../../../model/DisableAllCurrencyForAccountEvent';
import { UtilsService } from '../../service/UtilsService';
import { EnableAllCurrencyForAccountEvent } from '../../../model/EnableAllCurrencyForAccountEvent';
import { RecalculateTargetEvent } from '../../../model/RecalculateTargetEvent';
import { AccountState } from '../../service/AccountState';
import { PERMISSION, UserClient } from '@clearing-hub/common';
import { ProgressSpinnerService } from '../../service/progress-spinner.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  @ViewChild('header')
  header: HeaderComponent;

  EXCHANGES = EXCHANGES;

  pushEnabled = true;

  failedCurrencis: any[];

  errorResponse: any;

  activeTab = 0;

  activeTabName: string;

  wallet: Wallet;
  walletBitfinex: Wallet;
  walletBitfinexSwap: Wallet;

  // BFX loan
  loan: BitfinexLoan;
  loanPrecision = 0;
  notionalLoan: ProgressBarModel;
  activeLoan: ProgressBarModel;
  currentFXCHLimit: number;
  //

  counterPaused: boolean;

  // BFX features
  isBitfinexTargetEnabled: Json<string, Json<number, Json<string, boolean>>>;
  isBitfinexSwapTargetEnabled: Json<
    string,
    Json<number, Json<string, boolean>>
  >;
  //

  // Session
  currentUser: UserClient;
  //

  // Header
  accounts: Array<string>;
  // ------

  // Config
  alwaysDisplayedCurrencies: Array<string>;
  currencyDecimalPrecision: any = {};
  currencyRoundingScale: any = {};
  maxAllocationAmountPercentage: number;
  //

  // target: {[exchange: string]: {[abosAccountId: string]: {[bitfinexAccountId: string]: {[ccy: string]: string | number}}}};
  //           Exchange     abosAccId    BFX id      ccy      position
  //           Exchange     BFX id       BFX id      ccy      position
  target: Json<
    string,
    Json<string, Json<number, Json<string, number | string>>>
  >;
  bitfinexTargetInUSD: Json<
    string,
    Json<number, Json<string, number | string>>
  >;

  accountStates: Json<string, Json<string, Json<number, AccountState>>>;

  // Calculations
  sumOfTargetAmountsInUSDForAccounts: Json<string, Json<string, number>> = {};
  sumOfTargetAmountsInUSD = 0;
  // netEquityInUSDMaxEPerAccount: any = {};
  //

  isSelectorDisabled: Json<string, Json<number, boolean>> = {};

  // responseRegex = /\d+/g;
  responseRegex = /[1-9][0-9]*(?:\/[1-9][0-9])*/g;
  // responseRegex = /[-+]?[0-9]*\.?[0-9]*/g;

  config: ServerConfig;
  EnvironmentType = EnvironmentType;

  PERMISSION_ENUM = PERMISSION;

  constructor(
    private readonly positionService: PositionService,
    private readonly spinnerService: ProgressSpinnerService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly mappingService: MappingService,
    private readonly sessionService: SessionService,
    private readonly applicationStore: Store<ApplicationState>,
    private readonly toastr: ToastrService,
    private readonly decimalPipe: DecimalPipe,
  ) {}

  init() {
    this.walletBitfinex = JSON.parse(JSON.stringify(this.wallet));
    this.walletBitfinexSwap = JSON.parse(JSON.stringify(this.wallet));

    if (this.currentUser.permissions.includes(PERMISSION.BITFINEX_READ)) {
      this.target[Exchange.BITFINEX] = {};
    }
    if (
      this.currentUser.permissions.includes(PERMISSION.BITFINEX_SWAP_READ) ||
      this.currentUser.permissions.includes(PERMISSION.BITFINEX_SWAP_WRITE)
    ) {
      this.target[Exchange.BITFINEX_SWAP] = {};
    }
    this.initCurrenciesFromBitfinex();
    this.initCurrenciesFromBitfinexSwap();
    this.initBitfinexEnabledTargetColumns();
    this.initLoan(this.wallet.bitfinexLoan);
    this.initAccounts();
  }

  ngOnInit(): void {
    this.applicationStore
      .select(initApplicationSelector)
      .subscribe((config) => {
        this.config = config;
      });
    this.alwaysDisplayedCurrencies = ['BTC', 'EUR', 'USD', 'JPY', 'BCA'];
    this.currencyRoundingScale = {
      BAB: 10,
      BAT: 1000,
      BTC: 0.1,
      BCH: 10,
      ETH: 1,
      LTC: 10,
      OMG: 100,
      USD: 1000,
      UST: 1000,
      XLM: 10000,
      XRP: 10000,
    };
    this.maxAllocationAmountPercentage = 95;

    this.target = {};
    this.bitfinexTargetInUSD = {};
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.wallet = this.activatedRoute.snapshot.data['preload'];
    this.init();

    this.initLoan(this.wallet.bitfinexLoan);
    this.calculateDifferences(this.walletBitfinex.positions, BITFINEX_LABEL);
  }

  handleAccountDisplay(selectedAccounts: Array<string>) {
    this.sessionService.setUserCache(
      new UserCache(
        this.isBitfinexTargetEnabled,
        this.currentUser,
        selectedAccounts,
      ),
    );
    this.accounts.forEach((a) => {
      if (!selectedAccounts.includes(a)) {
        // this.disableAllCurrencyForAccount(a.abosAccountId, false);
        this.disableAllCurrencyForAccount(
          { abosAccountId: a, isSwap: false },
          false,
        );
        this.positionService.disableAllCcyForAccountEvent.emit({
          abosAccountId: a,
          isSwap: false,
          // bitfinexAccountId: 4
        });
      }
    });

    // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    selectedAccounts.forEach((a) => {
      const isBitfinexTargetEnabledKeys = Object.keys(
        this.isBitfinexTargetEnabled[a],
      );
      if (!this.header.selectedAccounts.includes(a)) {
        const userCache = this.sessionService.getUserCache();
        this.isBitfinexTargetEnabled[a] = userCache.isBitfinexTargetEnabled[a];
        this.calculateDifferences(
          this.walletBitfinex.positions,
          Exchange.BITFINEX,
        );
        if (
          isBitfinexTargetEnabledKeys.filter(
            (item) => this.isBitfinexTargetEnabled[a][item],
          ).length === isBitfinexTargetEnabledKeys.length
        ) {
          this.positionService.enableAllCcyForAccountEvent.emit({
            abosAccountId: a,
            // bitfinexAccountId: 2,
            isSwap: false,
          });
        }
      }
    });
  }

  initCurrenciesFromBitfinex() {
    this.walletBitfinex.positions.forEach((pos) => {
      this.walletBitfinex.availableBitfinexCCYS.forEach((ccy) => {
        const mappedCcy = this.mappingService.getMappedCurrency(
          this.wallet.currencyMappings,
          ccy,
          EXCHANGES.bitfinex,
        );
        if (
          pos.ccyPositions[mappedCcy] === undefined ||
          pos.ccyPositions[mappedCcy] === null
        ) {
          pos.ccyPositions[mappedCcy] = new CurrencyPosition(mappedCcy);
        }
      });
    });
  }

  initCurrenciesFromBitfinexSwap() {
    this.walletBitfinexSwap.positions.forEach((pos) => {
      this.walletBitfinexSwap.availableBitfinexCCYS.forEach((ccy) => {
        const mappedCcy = this.mappingService.getMappedCurrency(
          this.wallet.currencyMappings,
          ccy,
          EXCHANGES.bitfinex,
        );
        if (
          pos.ccyPositions[mappedCcy] === undefined ||
          pos.ccyPositions[mappedCcy] === null
        ) {
          pos.ccyPositions[mappedCcy] = new CurrencyPosition(mappedCcy);
        }
      });
    });
  }

  pullAll() {
    this.positionService
      .getWallet(this.alwaysDisplayedCurrencies)
      .subscribe((resp: Wallet) => {
        this.spinnerService.decrease();
        this.wallet = resp;
        this.init();
        this.calculateDifferences(
          this.walletBitfinex.positions,
          BITFINEX_LABEL,
        );
        this.header.restartCountdown();
      });
  }

  initBitfinexEnabledTargetColumns() {
    const cache = this.sessionService.getUserCache();
    this.isBitfinexTargetEnabled = {};
    this.isBitfinexSwapTargetEnabled = {};
    this.walletBitfinex.positions.forEach((pos) => {
      if (pos && pos.account && pos.account.abosAccountId && pos.ccyPositions) {
        if (!this.isBitfinexTargetEnabled[pos.account.abosAccountId]) {
          this.isBitfinexTargetEnabled[pos.account.abosAccountId] = {};
        }
        this.isBitfinexTargetEnabled[pos.account.abosAccountId][
          pos.account.bitfinexAccountId
        ] = {};
        Object.keys(pos.ccyPositions).forEach((cc) => {
          if (
            this.currentUser.permissions.includes(PERMISSION.BITFINEX_READ) ||
            this.currentUser.permissions.includes(PERMISSION.BITFINEX_WRITE)
          ) {
            if (
              cache &&
              cache.isBitfinexTargetEnabled &&
              cache.isBitfinexTargetEnabled[pos.account.abosAccountId] &&
              cache.isBitfinexTargetEnabled[pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc] !== undefined &&
              cache.isBitfinexTargetEnabled[pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc] !== null
            ) {
              this.isBitfinexTargetEnabled[pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc] =
                cache.isBitfinexTargetEnabled[pos.account.abosAccountId][
                  pos.account.bitfinexAccountId
                ][cc];
            } else if (
              this.wallet.availableBitfinexCCYS.includes(
                this.mappingService.getInvertedMappedCurrency(
                  this.wallet.currencyMappings,
                  cc,
                  EXCHANGES.bitfinex,
                ),
              )
            ) {
              this.isBitfinexTargetEnabled[pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc] = true;
            } else {
              this.isBitfinexTargetEnabled[pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc] = false;
            }
          }
        });
      }
    });
    this.walletBitfinex.positions.forEach((pos) => {
      if (
        pos &&
        pos.account &&
        pos.account.bitfinexAccountId &&
        pos.ccyPositions &&
        !isNaN(Number(pos.account.bitfinexAccountId))
      ) {
        this.isBitfinexSwapTargetEnabled[pos.account.bitfinexAccountId] = {};
        this.isBitfinexSwapTargetEnabled[pos.account.bitfinexAccountId][
          pos.account.bitfinexAccountId
        ] = {};
        Object.keys(pos.ccyPositions).forEach((cc) => {
          if (
            this.currentUser.permissions.includes(
              PERMISSION.BITFINEX_SWAP_WRITE,
            ) ||
            this.currentUser.permissions.includes(PERMISSION.BITFINEX_SWAP_READ)
          ) {
            if (
              cache &&
              cache.isBitfinexSwapTargetEnabled &&
              cache.isBitfinexSwapTargetEnabled[
                pos.account.bitfinexAccountId
              ] &&
              cache.isBitfinexSwapTargetEnabled[pos.account.bitfinexAccountId][
                pos.account.bitfinexAccountId
              ][cc] !== undefined &&
              cache.isBitfinexSwapTargetEnabled[pos.account.bitfinexAccountId][
                cc
              ] !== null
            ) {
              this.isBitfinexSwapTargetEnabled[pos.account.bitfinexAccountId][
                pos.account.bitfinexAccountId
              ][cc] =
                cache.isBitfinexSwapTargetEnabled[
                  pos.account.bitfinexAccountId
                ][pos.account.bitfinexAccountId][cc];
            } else if (
              this.wallet.availableBitfinexCCYS.includes(
                this.mappingService.getInvertedMappedCurrency(
                  this.wallet.currencyMappings,
                  cc,
                  EXCHANGES.bitfinex,
                ),
              )
            ) {
              this.isBitfinexSwapTargetEnabled[pos.account.bitfinexAccountId][
                pos.account.bitfinexAccountId
              ][cc] = true;
            } else {
              this.isBitfinexSwapTargetEnabled[pos.account.bitfinexAccountId][
                pos.account.bitfinexAccountId
              ][cc] = false;
            }
          }
        });
      }
    });
  }

  pull(pullEvent: PullEvent, recalculateTarget = true) {
    this.positionService
      .pull(
        pullEvent.abosAccountId,
        ['BTC', 'EUR', 'USD', 'JPY', 'BCA'],
        Number(pullEvent.bitfinexAccountId),
      )
      .subscribe((resp: Wallet) => {
        // this.positionsMap.get(pullEvent.exchange).
        this.wallet.currencyTypes = resp.currencyTypes;
        // this.wallet.midPrices = resp.midPrices;
        this.wallet.tresholds = resp.tresholds;
        this.wallet.availableBitfinexCCYS = resp.availableBitfinexCCYS;
        const accountPosition = this.wallet.positions.find(
          (p) => p.account.abosAccountId === pullEvent.abosAccountId,
        );
        accountPosition.ccyPositions = resp.positions[0].ccyPositions;

        this.walletBitfinex.availableBitfinexCCYS.forEach((ccy) => {
          const mappedCcy = this.mappingService.getMappedCurrency(
            this.wallet.currencyMappings,
            ccy,
            EXCHANGES.bitfinex,
          );
          if (!accountPosition.ccyPositions[mappedCcy]) {
            accountPosition.ccyPositions[mappedCcy] = new CurrencyPosition(
              mappedCcy,
            );
          }
        });

        Object.keys(accountPosition.ccyPositions).forEach((k) => {
          if (resp.positions[0].ccyPositions[k]) {
            accountPosition.ccyPositions[k] = {
              ...resp.positions[0].ccyPositions[k],
            };
          }
        });

        if (pullEvent.exchange === Exchange.BITFINEX) {
          this.walletBitfinex.positions.find(
            (p) => p.account.abosAccountId === pullEvent.abosAccountId,
          ).ccyPositions = accountPosition.ccyPositions;
        }

        this.initLoan(resp.bitfinexLoan);
        if (recalculateTarget) {
          this.calculateDifferences(resp.positions, pullEvent.exchange, {
            abosAccountId: pullEvent.abosAccountId,
            bitfinexAccountId: pullEvent.bitfinexAccountId,
          });
        }
      });
  }

  initAccounts() {
    this.accounts = this.walletBitfinex.accountsConfig.bitfinex;
  }

  initLoan(loan): void {
    this.loan = new BitfinexLoan();
    this.loan.maxNotionalLoanSizeInUSD = Number(
      Number(loan.maxNotionalLoanSizeInUSD).toFixed(this.loanPrecision),
    );
    this.loan.maxActiveLoanSizeInUSD = Number(
      Number(loan.maxActiveLoanSizeInUSD).toFixed(this.loanPrecision),
    );
    this.loan.currentNotionalLoanSizeInUSD = Number(
      Number(loan.currentNotionalLoanSizeInUSD).toFixed(this.loanPrecision),
    );
    this.loan.currentActiveLoanSizeInUSD = Number(
      Number(loan.currentActiveLoanSizeInUSD).toFixed(this.loanPrecision),
    );
    this.loan.currentEquityInUSD = Number(
      Number(loan.currentEquityInUSD).toFixed(this.loanPrecision),
    );
    this.loan.minEquityInUSD = Number(
      Number(loan.minEquityInUSD).toFixed(this.loanPrecision),
    );

    this.notionalLoan = new ProgressBarModel(
      this.loan.maxNotionalLoanSizeInUSD,
      this.loan.currentNotionalLoanSizeInUSD,
    );
    this.activeLoan = new ProgressBarModel(
      this.loan.maxActiveLoanSizeInUSD,
      this.loan.currentActiveLoanSizeInUSD,
    );
    this.currentFXCHLimit =
      (this.notionalLoan.max - this.activeLoan.value) *
      (this.maxAllocationAmountPercentage / 100);
  }

  selectTab(index: number, exchangeName: string) {
    this.activeTab = index;
    this.activeTabName = exchangeName;
  }

  calculateDifferences(
    positions: Pos[],
    exchangeName: string,
    event?: RecalculateTargetEvent,
  ) {
    if (
      UtilsService.isNotUndefinedOrNull(event) &&
      UtilsService.isNotUndefinedOrNull(event.abosAccountId) &&
      UtilsService.isNotUndefinedOrNull(event.bitfinexAccountId)
    ) {
      const position = positions.find(
        (pos) =>
          pos.account.abosAccountId === event.abosAccountId &&
          pos.account.bitfinexAccountId === event.bitfinexAccountId,
      );
      this.calculateDifference(position, exchangeName);
      if (exchangeName === BITFINEX_LABEL) {
        this.recalculateSumIfTargetAmountInUSD();

        if (this.currentFXCHLimit < this.sumOfTargetAmountsInUSD) {
          this.calculateTargetWithRatio([position]);
        }
      }
    } else {
      this.sumOfTargetAmountsInUSDForAccounts = {};
      positions.forEach((pos) => {
        this.initBfxSwapTarget(pos);
        this.calculateDifference(pos, exchangeName);
      });
      if (exchangeName === BITFINEX_LABEL) {
        this.recalculateSumIfTargetAmountInUSD();

        if (this.currentFXCHLimit < this.sumOfTargetAmountsInUSD) {
          this.calculateTargetWithRatio(positions);
        }
      }
    }
  }

  calculateTargetWithRatio(positions: Array<Pos>) {
    positions
      .filter((pos) => pos.exchange !== Exchange.BITFINEX_SWAP)
      .forEach((pos) => {
        if (!pos || !pos.account || !pos.ccyPositions) {
          return;
        }
        const accountRemainderNotionalEquityInUSD =
          (this.sumOfTargetAmountsInUSDForAccounts[pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ] /
            this.sumOfTargetAmountsInUSD) *
          this.currentFXCHLimit;
        const accountRemainderNotionalEquityInUSDDecreasedByRatio =
          accountRemainderNotionalEquityInUSD;

        Object.keys(pos.ccyPositions).forEach((cc) => {
          if (
            !this.isBitfinexTargetEnabled[pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ][cc] ||
            !this.target[Exchange.BITFINEX][pos.account.abosAccountId] ||
            this.target[Exchange.BITFINEX][pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ][cc] === ''
          ) {
            return;
          }
          const midPrice = this.getMidPrice(cc);
          if (
            this.target[Exchange.BITFINEX][pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ][cc] === 0 ||
            isNaN(
              Number(
                this.target[Exchange.BITFINEX][pos.account.abosAccountId][
                  pos.account.bitfinexAccountId
                ][cc],
              ),
            ) ||
            !midPrice
          ) {
            return;
          }
          const originalTargetEquityInUSDRate =
            (Number(
              this.target[Exchange.BITFINEX][pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc],
            ) *
              this.getMidPrice(cc)) /
            this.sumOfTargetAmountsInUSDForAccounts[pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ];
          this.target[Exchange.BITFINEX][pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ][cc] =
            (originalTargetEquityInUSDRate *
              accountRemainderNotionalEquityInUSDDecreasedByRatio) /
            this.getMidPrice(cc);
          this.bitfinexTargetInUSD[pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ][cc] =
            Number(
              this.target[Exchange.BITFINEX][pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc],
            ) * this.getMidPrice(cc);
          this.formatTargetByAbosAccountIdAndCurrency(
            pos.account.abosAccountId,
            pos.account.bitfinexAccountId,
            cc,
          );
        });
      });
  }

  initBfxSwapTarget(pos: Pos) {
    if (
      (this.currentUser.permissions.includes(PERMISSION.BITFINEX_SWAP_READ) ||
        this.currentUser.permissions.includes(
          PERMISSION.BITFINEX_SWAP_WRITE,
        )) &&
      pos.exchange === Exchange.BITFINEX_SWAP
    ) {
      this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId] = {};
      this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId][
        pos.account.bitfinexAccountId
      ] = {};
    }

    Object.keys(pos.ccyPositions).forEach((cc) => {
      if (
        (this.currentUser.permissions.includes(PERMISSION.BITFINEX_SWAP_READ) ||
          this.currentUser.permissions.includes(
            PERMISSION.BITFINEX_SWAP_WRITE,
          )) &&
        pos.exchange === Exchange.BITFINEX_SWAP
      ) {
        this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId][
          pos.account.bitfinexAccountId
        ][cc] = '';
      }
    });
  }

  calculateDifference(pos: Pos, exchangeName: string) {
    if (exchangeName === BITFINEX_LABEL) {
      if (!this.target[Exchange.BITFINEX][pos.account.abosAccountId]) {
        this.target[Exchange.BITFINEX][pos.account.abosAccountId] = {};
      }
      this.target[Exchange.BITFINEX][pos.account.abosAccountId][
        pos.account.bitfinexAccountId
      ] = {};
      if (!this.bitfinexTargetInUSD[pos.account.abosAccountId]) {
        this.bitfinexTargetInUSD[pos.account.abosAccountId] = {};
      }
      this.bitfinexTargetInUSD[pos.account.abosAccountId][
        pos.account.bitfinexAccountId
      ] = {};
    }
    if (
      !(
        pos &&
        pos.ccyPositions !== undefined &&
        pos.netEquityPosition !== undefined
      ) /*|| this.ratioForAbosAccounts[pos.account.abosAccountId] === 0*/
    ) {
      return;
    }

    let priceForUSD;

    if (pos.clientAccountCurrency === 'USD') {
      priceForUSD = 1;
    } else {
      priceForUSD = this.wallet.midPrices[pos.clientAccountCurrency + 'USD']
        ? this.wallet.midPrices[pos.clientAccountCurrency + 'USD']
        : 1 / this.wallet.midPrices['USD' + pos.clientAccountCurrency];
    }

    const netEQInUSD = Math.trunc(pos.netEquityPosition * priceForUSD);

    const netEquityInUSDMaxE =
      netEQInUSD / this.wallet.tresholds[pos.account.abosAccountId] -
      Math.trunc(Number(pos.netOpenPosition) * priceForUSD);

    if (!this.sumOfTargetAmountsInUSDForAccounts[pos.account.abosAccountId]) {
      this.sumOfTargetAmountsInUSDForAccounts[pos.account.abosAccountId] = {};
    }
    this.sumOfTargetAmountsInUSDForAccounts[pos.account.abosAccountId][
      pos.account.bitfinexAccountId
    ] = 0;
    if (!this.bitfinexTargetInUSD[pos.account.abosAccountId]) {
      this.bitfinexTargetInUSD[pos.account.abosAccountId] = {};
    }
    this.bitfinexTargetInUSD[pos.account.abosAccountId][
      pos.account.bitfinexAccountId
    ] = {};
    Object.keys(pos.ccyPositions).forEach((cc) => {
      const midPrice = this.getMidPrice(cc);

      if (!midPrice) {
        this.target[Exchange.BITFINEX][pos.account.abosAccountId][
          pos.account.bitfinexAccountId
        ][cc] = '';
        return;
      }

      const netEquityInCCYmaxE = netEquityInUSDMaxE / midPrice;

      if (exchangeName === BITFINEX_LABEL) {
        if (
          this.target[Exchange.BITFINEX][pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ][cc] !== '' &&
          this.isBitfinexTargetEnabled[pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ][cc]
        ) {
          this.target[Exchange.BITFINEX][pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ][cc] =
            pos.ccyPositions[cc].tradePosition > 0
              ? pos.ccyPositions[cc].tradePosition + netEquityInCCYmaxE
              : netEquityInCCYmaxE;
          if (
            isNaN(
              Number(
                this.target[Exchange.BITFINEX][pos.account.abosAccountId][
                  pos.account.bitfinexAccountId
                ][cc],
              ),
            )
          ) {
            this.target[Exchange.BITFINEX][pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ][cc] = '';
          }
          this.bitfinexTargetInUSD[pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ][cc] =
            Number(
              this.target[Exchange.BITFINEX][pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc],
            ) * midPrice;
          this.formatTargetByAbosAccountIdAndCurrency(
            pos.account.abosAccountId,
            pos.account.bitfinexAccountId,
            cc,
          );

          if (
            Number(
              this.target[Exchange.BITFINEX][pos.account.abosAccountId][
                pos.account.bitfinexAccountId
              ][cc],
            ) < 0
          ) {
            this.target[Exchange.BITFINEX][pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ][cc] = 0;
            this.bitfinexTargetInUSD[pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ][cc] = 0;
          } else {
            if (
              !isNaN(
                Number(
                  this.bitfinexTargetInUSD[pos.account.abosAccountId][
                    pos.account.bitfinexAccountId
                  ][cc],
                ),
              )
            ) {
              this.sumOfTargetAmountsInUSDForAccounts[
                pos.account.abosAccountId
              ][pos.account.bitfinexAccountId] += Number(
                this.bitfinexTargetInUSD[pos.account.abosAccountId][
                  pos.account.bitfinexAccountId
                ][cc],
              );
            }
          }
        } else {
          this.target[Exchange.BITFINEX][pos.account.abosAccountId][
            pos.account.bitfinexAccountId
          ][cc] = '';
        }
      }
    });
  }

  getTargetForCcy(tradePosition: number, netEquityInCCYmaxE: number): number {
    return tradePosition > 0
      ? tradePosition + netEquityInCCYmaxE
      : netEquityInCCYmaxE;
  }

  recalculateSumIfTargetAmountInUSD() {
    this.sumOfTargetAmountsInUSD = 0;
    Object.keys(this.sumOfTargetAmountsInUSDForAccounts).forEach((k) => {
      Object.keys(this.target[Exchange.BITFINEX][k]).forEach((bk) => {
        this.sumOfTargetAmountsInUSD +=
          this.sumOfTargetAmountsInUSDForAccounts[k][bk];
      });
    });
    if (this.notionalLoan && this.activeLoan) {
      this.currentFXCHLimit =
        (this.notionalLoan.max - this.activeLoan.value) *
        (this.maxAllocationAmountPercentage / 100);
    }
  }

  getMidPrice(currency: string) {
    const mappedCcy = currency;
    let midPrice = this.wallet.midPrices[mappedCcy + 'USD'];
    const invertedMidPrice = this.wallet.midPrices['USD' + mappedCcy];

    if (mappedCcy === 'USD') {
      midPrice = 1;
    } else if (!midPrice) {
      if (!invertedMidPrice) {
        return null;
      }
      midPrice = 1 / invertedMidPrice;
    }
    return midPrice;
  }

  pushData(pos: Pos) {
    this.pushEnabled = false;
    const dto = [];
    for (const curr of Object.keys(
      this.target[Exchange.BITFINEX][pos.account.abosAccountId][
        pos.account.bitfinexAccountId
      ],
    )) {
      const invertedMappedCcy = this.mappingService.getInvertedMappedCurrency(
        this.walletBitfinex.currencyMappings,
        curr,
        BITFINEX_LABEL.toLowerCase(),
      );
      if (
        this.target[Exchange.BITFINEX][pos.account.abosAccountId][
          pos.account.bitfinexAccountId
        ][curr] === undefined ||
        this.target[Exchange.BITFINEX][pos.account.abosAccountId][
          pos.account.bitfinexAccountId
        ][curr] === null ||
        this.target[Exchange.BITFINEX][pos.account.abosAccountId][
          pos.account.bitfinexAccountId
        ][curr] === '' ||
        (this.header.showOnlyBitfinexEnabledAccounts &&
          !this.walletBitfinex.availableBitfinexCCYS.includes(
            invertedMappedCcy,
          ))
      ) {
        continue;
      }
      const amount = Number(
        (
          this.getMaskedPriceAsNumber(
            this.target[Exchange.BITFINEX][pos.account.abosAccountId][
              pos.account.bitfinexAccountId
            ][curr],
          ) - this.getBitfinexPositionForCcy(pos, curr)
        ).toFixed(8),
      );
      if (amount !== 0) {
        dto.push({
          currency: invertedMappedCcy,
          amount,
        });
      }
    }
    if (dto.length === 0) {
      this.pushEnabled = true;
      return;
    }
    const message = {
      funds: dto,
      clientAccountId: pos.account.abosAccountId,
      bitfinexAccountId: pos.account.bitfinexAccountId,
    };

    this.positionService.addFunds(message).subscribe(
      (resp) => {
        this.pushEnabled = true;
        if (resp.code === 200) {
          this.toastr.success(resp.message, null, { disableTimeOut: false });
        } else {
          Object.keys(resp.message).map((item) =>
            this.formatResponse(resp.message[item]),
          );
          this.errorResponse = resp;
          this.failedCurrencis = Object.keys(resp.message);
          this.failedCurrencis.forEach(
            (f) =>
              (this.errorResponse.message[f] = this.formatResponse(
                this.errorResponse.message[f],
              )),
          );
          setTimeout(() => {
            this.toastr.error(
              document.getElementById('errorTemplate').innerHTML,
              'There are currencies failed to update:',
              { enableHtml: true },
            );
          }, 20);
        }
        this.pull(
          new PullEvent(
            pos.account.abosAccountId,
            pos.account.bitfinexAccountId,
            Exchange.BITFINEX,
          ),
          false,
        );
      },
      (err) => {
        console.log(err);
        this.pushEnabled = true;
      },
    );
  }

  pushForBitfinexSwap(pos: Pos) {
    this.pushEnabled = false;
    const dto = [];
    for (const curr of Object.keys(
      this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId][
        pos.account.bitfinexAccountId
      ],
    )) {
      const invertedMappedCcy = this.mappingService.getInvertedMappedCurrency(
        this.walletBitfinex.currencyMappings,
        curr,
        BITFINEX_LABEL.toLowerCase(),
      );
      if (
        this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId][
          pos.account.bitfinexAccountId
        ][curr] === undefined ||
        this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId][
          pos.account.bitfinexAccountId
        ][curr] === null ||
        this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId][
          pos.account.bitfinexAccountId
        ][curr] === '' ||
        (this.header.showOnlyBitfinexEnabledAccounts &&
          !this.walletBitfinex.availableBitfinexCCYS.includes(
            invertedMappedCcy,
          ))
      ) {
        continue;
      }
      const amount = Number(
        (
          this.getMaskedPriceAsNumber(
            this.target[Exchange.BITFINEX_SWAP][pos.account.bitfinexAccountId][
              pos.account.bitfinexAccountId
            ][curr],
          ) - this.getBitfinexPositionForCcy(pos, curr)
        ).toFixed(8),
      );
      if (amount !== 0) {
        dto.push({
          currency: invertedMappedCcy,
          amount,
        });
      }
    }
    if (dto.length === 0) {
      this.pushEnabled = true;
      return;
    }
    this.positionService
      .pushSwapPositions({
        funds: dto,
        bitfinexAccountId: pos.account.bitfinexAccountId,
      })
      .subscribe(
        (resp) => {
          this.pushEnabled = true;
          if (resp.code === 200) {
            this.toastr.success(resp.message, null, { disableTimeOut: false });
          } else {
            Object.keys(resp.message).map((item) =>
              this.formatResponse(resp.message[item]),
            );
            this.errorResponse = resp;
            this.failedCurrencis = Object.keys(resp.message);
            this.failedCurrencis.forEach(
              (f) =>
                (this.errorResponse.message[f] = this.formatResponse(
                  this.errorResponse.message[f],
                )),
            );
            setTimeout(() => {
              this.toastr.error(
                document.getElementById('errorTemplate').innerHTML,
                'There are currencies failed to update:',
                { enableHtml: true },
              );
            }, 20);
          }

          this.pullSwapAccounts(
            pos.account.bitfinexAccountId,
            Number(
              this.getSwapNumberFromAccountName(
                pos.account.bitfinexAccountName,
              ),
            ),
          );
        },
        (err) => {
          console.log(err);
          this.pushEnabled = true;
        },
      );
  }

  getSwapNumberFromAccountName(name: string) {
    return Number(name.slice(0, name.indexOf('-')));
  }

  formatResponse(response: string): string {
    let m;
    const arrayOfNumbers: number[] = [];
    while ((m = this.responseRegex.exec(response)) != null) {
      for (const p of m) {
        arrayOfNumbers.push(p);
      }
    }

    if (arrayOfNumbers.length === 0) {
      return response;
    }

    let result = response;

    if (arrayOfNumbers.length === 1) {
      result = result.replace(
        arrayOfNumbers[0].toString(),
        this.decimalPipe.transform(arrayOfNumbers[0], '1.2-4'),
      );
    }

    if (arrayOfNumbers.length === 2) {
      const fractionNumber: number = Number(
        arrayOfNumbers[0].toString() + '.' + arrayOfNumbers[1].toString(),
      );
      result = result.replace(
        fractionNumber.toString(),
        this.decimalPipe.transform(fractionNumber, '1.2-4'),
      );
    }

    return result;
  }

  nullTarget(event: NullTargetEvent) {
    for (const curr of Object.keys(
      this.target[Exchange.BITFINEX][event.abosAccountId][
        event.bitfinexAccountId
      ],
    )) {
      if (
        this.isBitfinexTargetEnabled[event.abosAccountId][
          event.bitfinexAccountId
        ][curr]
      ) {
        this.target[Exchange.BITFINEX][event.abosAccountId][
          event.bitfinexAccountId
        ][curr] = 0;
        this.bitfinexTargetInUSD[event.abosAccountId][event.bitfinexAccountId][
          curr
        ] = 0;
      }
    }
  }

  emptyTarget(event: EmptyTargetEvent) {
    for (const curr of Object.keys(
      this.target[Exchange.BITFINEX][event.abosAccountId][
        event.bitfinexAccountId
      ],
    )) {
      this.target[Exchange.BITFINEX][event.abosAccountId][
        event.bitfinexAccountId
      ][curr] = '';
      this.bitfinexTargetInUSD[event.abosAccountId][event.bitfinexAccountId][
        curr
      ] = '';
    }
  }

  enableAllCurrencyForAccount(event: EnableAllCurrencyForAccountEvent) {
    const target = event.isSwap
      ? this.isBitfinexSwapTargetEnabled
      : this.isBitfinexTargetEnabled;
    if (this.isSelectorDisabled[event.abosAccountId]) {
      this.isSelectorDisabled[event.abosAccountId][event.bitfinexAccountId] =
        false;
    }
    Object.keys(target[event.abosAccountId]).forEach((bfxId) => {
      Object.keys(target[event.abosAccountId][bfxId]).forEach((ccy) => {
        target[event.abosAccountId][bfxId][ccy] = true;
      });
    });

    this.sessionService.setUserCache(
      new UserCache(
        this.isBitfinexTargetEnabled,
        this.currentUser,
        this.header.selectedAccounts,
      ),
    );
    this.calculateDifferences(this.walletBitfinex.positions, BITFINEX_LABEL, {
      abosAccountId: event.abosAccountId,
      bitfinexAccountId: event.bitfinexAccountId,
    });
  }

  disableAllCurrencyForAccount(
    event: DisableAllCurrencyForAccountEvent,
    storeCache = true,
  ) {
    const target = event.isSwap
      ? this.isBitfinexSwapTargetEnabled
      : this.isBitfinexTargetEnabled;
    if (
      !UtilsService.isNotUndefinedOrNull(
        this.isSelectorDisabled[event.abosAccountId],
      )
    ) {
      this.isSelectorDisabled[event.abosAccountId] = {};
    }
    this.isSelectorDisabled[event.abosAccountId][event.bitfinexAccountId] =
      true;
    const exch = event.isSwap ? Exchange.BITFINEX_SWAP : Exchange.BITFINEX;
    if (this.target[exch][event.abosAccountId]) {
      Object.keys(this.target[exch][event.abosAccountId]).forEach((ccy) => {
        if (UtilsService.isNotUndefinedOrNull(event.bitfinexAccountId)) {
          Object.keys(this.target[exch][event.abosAccountId]).forEach((k) => {
            this.target[exch][event.abosAccountId][k][ccy] = '';
          });
        } else {
          this.target[exch][event.abosAccountId][event.bitfinexAccountId][ccy] =
            '';
        }
      });
    }
    Object.keys(target[event.abosAccountId]).forEach((bfxId) => {
      Object.keys(target[event.abosAccountId][bfxId]).forEach((ccy) => {
        target[event.abosAccountId][bfxId][ccy] = false;
      });
    });

    if (storeCache) {
      this.sessionService.setUserCache(
        new UserCache(target, this.currentUser, this.header.selectedAccounts),
      );
    }
    // this.changeRatioForAbosAccountWithAnimation(abosAccountId, 0);
    // this.calculateDifferences(this.positionsMap.get(Exchange.BITFINEX), BITFINEX_LABEL);
    if (!event.isSwap) {
      this.calculateDifferences(this.walletBitfinex.positions, BITFINEX_LABEL);
    }
  }

  recalculateTargetInUSDByAccountAndCurrency(
    event: RecalculateTargetInUSDEvent,
  ) {
    // this.pauseCountdownIfRunning();
    // this.positionService.pauseCounterEvent.emit();
    // this.bitfinexTargetInUSD[event.abosAccountId][event.currency] = this.getMaskedPriceAsNumber(event.amount) * this.getMidPrice(event.currency);
    // const precisionForUSD = this.currencyDecimalPrecision['USD'];
    // if (precisionForUSD === undefined) {
    //   return;
    // }
    // if (precisionForUSD === 0) {
    //   this.bitfinexTargetInUSD[event.abosAccountId][event.currency] = Math.trunc(this.bitfinexTargetInUSD[event.abosAccountId][event.currency]);
    // } else {
    //   this.bitfinexTargetInUSD[event.abosAccountId][event.currency] = Number(this.bitfinexTargetInUSD[event.abosAccountId][event.currency].toFixed(precisionForUSD));
    // }
    this.pauseCountdownIfRunning();
    const midPrice = this.getMidPrice(event.currency);
    if (!midPrice) {
      return;
    }
    this.target[EXCHANGES.bitfinex][event.abosAccountId][
      event.bitfinexAccountId
    ][event.currency] = this.getMaskedPriceAsNumber(event.amount) * midPrice;
    const roundingScale = this.currencyRoundingScale['USD'];
    if (!roundingScale) {
      return;
    }
    this.formatNumber(
      Number(
        this.target[EXCHANGES.bitfinex][event.abosAccountId][event.currency],
      ),
      roundingScale,
    );
  }

  formatNumber(num: number, scale: number): number {
    if (scale >= 1) {
      return Math.trunc(num);
    }
    const precision: number = scale.toString().split('.')[1].length;
    return Number(num.toFixed(precision));
  }

  recalculateTargetInGivenCurrencyByAccountAndCurrency(
    event: RecalculateTargetInGivenCurrencyEvent,
  ) {
    // this.positionService.pauseCounterEvent.emit();
    // this.target[Exchange.BITFINEX][event.abosAccountId][event.currency] = this.getMaskedPriceAsNumber(event.amount) / this.getMidPrice(event.currency);
    // const precision = this.currencyDecimalPrecision[event.currency];
    // if (precision === undefined) {
    //   return;
    // }
    // if (precision === 0) {
    //   this.target[Exchange.BITFINEX][event.abosAccountId][event.currency] = Math.trunc(this.target[Exchange.BITFINEX][event.abosAccountId][event.currency]);
    // } else {
    //   this.target[Exchange.BITFINEX][event.abosAccountId][event.currency] = Number(this.target[Exchange.BITFINEX][event.abosAccountId][event.currency].toFixed(precision));
    // }
    this.pauseCountdownIfRunning();
    const midPrice = this.getMidPrice(event.currency);
    if (!midPrice) {
      return;
    }
    this.target[EXCHANGES.bitfinex][event.abosAccountId][
      event.bitfinexAccountId
    ][event.currency] = this.getMaskedPriceAsNumber(event.amount) / midPrice;
    const roundingScale = this.currencyRoundingScale[event.currency];
    if (!roundingScale) {
      return;
    }
    this.formatNumber(
      Number(
        this.target[EXCHANGES.bitfinex][event.abosAccountId][event.currency],
      ),
      roundingScale,
    );
  }

  pauseCountdownIfRunning() {
    if (this.counterPaused) {
      return;
    }
    this.header.stopCountdown();
    this.counterPaused = true;
  }

  formatTargetByAbosAccountIdAndCurrency(
    abosAccountId: string,
    bitfinexAccountId: number,
    currency: string,
  ): void {
    const roundingScale = this.currencyRoundingScale[currency];
    if (!roundingScale) {
      return;
    }

    if (
      isNaN(
        Number(
          this.target[Exchange.BITFINEX][abosAccountId][bitfinexAccountId][
            currency
          ],
        ),
      )
    ) {
      this.target[Exchange.BITFINEX][abosAccountId][bitfinexAccountId][
        currency
      ] = '';
      this.bitfinexTargetInUSD[abosAccountId][bitfinexAccountId][currency] = '';
      return;
    }

    if (
      this.target[Exchange.BITFINEX][abosAccountId][bitfinexAccountId][
        currency
      ] === null ||
      this.bitfinexTargetInUSD[abosAccountId][bitfinexAccountId][currency] ===
        undefined
    ) {
      this.target[Exchange.BITFINEX][abosAccountId][bitfinexAccountId][
        currency
      ] = '';
      this.bitfinexTargetInUSD[abosAccountId][bitfinexAccountId][currency] = '';
      return;
    }

    if (
      this.target[Exchange.BITFINEX][abosAccountId][bitfinexAccountId][
        currency
      ] === 0
    ) {
      this.bitfinexTargetInUSD[abosAccountId][bitfinexAccountId][currency] = 0;
      return;
    }

    this.target[Exchange.BITFINEX][abosAccountId][bitfinexAccountId][currency] =
      Math.trunc(
        Number(
          this.target[Exchange.BITFINEX][abosAccountId][bitfinexAccountId][
            currency
          ],
        ) / roundingScale,
      ) * roundingScale;

    const roundingScaleForUSD = this.currencyRoundingScale['USD'];
    if (!roundingScaleForUSD) {
      return;
    }
    this.bitfinexTargetInUSD[abosAccountId][bitfinexAccountId][currency] =
      Math.trunc(
        Number(
          this.bitfinexTargetInUSD[abosAccountId][bitfinexAccountId][currency],
        ) / roundingScale,
      ) * roundingScale;
  }

  getFormattedTargetByPositionAndCcy(position: number, ccy: string): number {
    const roundingScale = this.currencyRoundingScale[ccy];
    if (!roundingScale) {
      return position;
    }
    return Math.trunc(position / roundingScale) * roundingScale;
  }

  getMaskedPriceAsNumber(price) {
    if (typeof price === 'string') {
      return Number(price.split(',').join(''));
    }
    return Number(price);
  }

  getBitfinexPositionForCcy(position: Pos, sixLetterCode: string) {
    return position.ccyPositions[sixLetterCode]?.bitfinexPosition
      ? position.ccyPositions[sixLetterCode].bitfinexPosition
      : 0;
  }

  bitfinexCurrencyEnabledChanged(event: BitfinexCurrencyEnabledChange) {
    const target = event.isSwap
      ? this.isBitfinexSwapTargetEnabled
      : this.isBitfinexTargetEnabled;
    if (event.isEnabled) {
      if (
        this.isSelectorDisabled[event.abosAccountId] &&
        this.isSelectorDisabled[event.abosAccountId][event.bitfinexAccountId]
      ) {
        this.isSelectorDisabled[event.abosAccountId][event.bitfinexAccountId] =
          false;
      }
    }
    target[event.abosAccountId][event.bitfinexAccountId][event.currency] =
      event.isEnabled;
    this.sessionService.setUserCache(
      new UserCache(target, this.currentUser, this.header.selectedAccounts),
    );
    if (!event.isEnabled) {
      this.target[event.isSwap ? Exchange.BITFINEX_SWAP : Exchange.BITFINEX][
        event.isSwap ? event.bitfinexAccountId : event.abosAccountId
      ][event.bitfinexAccountId][event.currency] = '';
    }
    if (
      !Object.values(target[event.abosAccountId][event.bitfinexAccountId]).some(
        (item) => item,
      )
    ) {
      this.isSelectorDisabled[event.abosAccountId][event.bitfinexAccountId] =
        true;
    }
    this.calculateDifferences(this.walletBitfinex.positions, BITFINEX_LABEL);
  }

  disableAllCurrencyForAllAccount(): void {
    this.positionService.allAccountStateChangeEvent.emit(false);
    Object.keys(this.isBitfinexTargetEnabled).forEach((k) => {
      Object.keys(this.isBitfinexTargetEnabled[k]).forEach((bfxId) => {
        Object.keys(this.isBitfinexTargetEnabled[k][bfxId]).forEach((ccy) => {
          this.isBitfinexTargetEnabled[k][bfxId][ccy] = false;
        });
      });
    });
    this.sessionService.setUserCache(
      new UserCache(
        this.isBitfinexTargetEnabled,
        this.currentUser,
        this.header.selectedAccounts,
      ),
    );
  }

  enableAllCurrencyForAllAccount(): void {
    this.positionService.allAccountStateChangeEvent.emit(true);
    Object.keys(this.isBitfinexTargetEnabled).forEach((k) => {
      Object.keys(this.isBitfinexTargetEnabled[k]).forEach((bfxId) => {
        Object.keys(this.isBitfinexTargetEnabled[k][bfxId]).forEach((ccy) => {
          this.isBitfinexTargetEnabled[k][bfxId][ccy] = true;
        });
      });
    });
    this.sessionService.setUserCache(
      new UserCache(
        this.isBitfinexTargetEnabled,
        this.currentUser,
        this.header.selectedAccounts,
      ),
    );
  }

  pullSwapAccounts(bitfinexAccountId: any, swapNumber: number) {
    this.positionService
      .pullSwapPosition(Number(swapNumber))
      .subscribe((resp: Pos) => {
        // const accountPosition = this.walletBitfinex.positions.find(p => p.account.bitfinexAccountId === bitfinexAccountId);
        // const newPositions = resp.find(p => p.account.bitfinexAccountId === bitfinexAccountId);
        // accountPosition.ccyPositions = resp;

        this.walletBitfinexSwap.positions.map((p) => {
          if (p.account.bitfinexAccountId === bitfinexAccountId) {
            p.ccyPositions = resp.ccyPositions;
          }
          return p;
        });
      });
  }

  swapPositionsComparator(a: Pos, b: Pos) {
    let aPos = false;
    let bPos = false;
    Object.keys(a.ccyPositions).forEach((k) => {
      if (this.isNotDefinedOrNull(a.ccyPositions[k].bitfinexPosition)) {
        aPos = true;
      }
    });
    Object.keys(b.ccyPositions).forEach((k) => {
      if (this.isNotDefinedOrNull(b.ccyPositions[k].bitfinexPosition)) {
        bPos = true;
      }
    });
    if (aPos && !bPos) {
      return -1;
    }
    if (!aPos && bPos) {
      return 1;
    }

    return 0;
  }

  isNotDefinedOrNull(value: any) {
    return value !== undefined && value !== null;
  }
}
